import { createSlice } from "@reduxjs/toolkit";
import {
  OfficeInitialStatus,
  OfficeListData,
} from "../../../types/office/office";
import {
  createOfficeAsync,
  deleteOfficeAsync,
  getAllOfficeListAsync,
  updateOfficeAsync,
} from "./OfficeApi";

const initialState: OfficeInitialStatus<OfficeListData> = {
  loading: false,
  manageLoading: false,
  officeList: [],
  countOffice: 0,
};

const officeSlice = createSlice({
  name: "admin-office",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    // create
    builder
      .addCase(createOfficeAsync.pending, (state) => {
        state.manageLoading = true;
      })
      .addCase(createOfficeAsync.fulfilled, (state) => {
        state.manageLoading = false;
      })
      .addCase(createOfficeAsync.rejected, (state) => {
        state.manageLoading = false;
      });

    // get office list
    builder
      .addCase(getAllOfficeListAsync.pending, (state) => {
        state.loading = true;
        state.officeList = [];
      })
      .addCase(getAllOfficeListAsync.fulfilled, (state, action) => {
        state.loading = false;
        state.officeList = action.payload.data;
        state.countOffice = action.payload.length;
      })
      .addCase(getAllOfficeListAsync.rejected, (state) => {
        state.loading = false;
        state.officeList = [];
        state.countOffice = 0;
      });

    // update
    builder
      .addCase(updateOfficeAsync.pending, (state) => {
        state.manageLoading = true;
      })
      .addCase(updateOfficeAsync.fulfilled, (state) => {
        state.manageLoading = false;
      })
      .addCase(updateOfficeAsync.rejected, (state) => {
        state.manageLoading = false;
      });
    // delete
    builder
      .addCase(deleteOfficeAsync.pending, (state) => {
        state.manageLoading = true;
      })
      .addCase(deleteOfficeAsync.fulfilled, (state) => {
        state.manageLoading = false;
      })
      .addCase(deleteOfficeAsync.rejected, (state) => {
        state.manageLoading = false;
      });
  },
});

export default officeSlice;
